import React__default from 'react';

var Triangle4 = function Triangle4(props) {
  var className = props.className,
    style = props.style;
  return /*#__PURE__*/React__default.createElement("svg", {
    className: className,
    style: style,
    width: "93",
    height: "103",
    viewBox: "0 0 93 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "93",
    height: "103"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "93",
    height: "103",
    fill: "#DBFBFB"
  })), /*#__PURE__*/React__default.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React__default.createElement("path", {
    opacity: "0.2",
    d: "M92.9997 -248.106V75.2007C92.9828 80.0636 91.6959 84.8376 89.2666 89.0493C86.8373 93.261 83.3501 96.764 79.1506 99.211C74.9512 101.658 70.1855 102.964 65.3262 102.999C60.4669 103.035 55.6827 101.798 51.4481 99.4125L-232.97 -62.3067C-237.232 -64.7478 -240.775 -68.2727 -243.239 -72.5244C-245.702 -76.7761 -247 -81.6037 -247 -86.5185C-247 -91.4333 -245.702 -96.2609 -243.239 -100.513C-240.775 -104.764 -237.232 -108.289 -232.97 -110.73L51.4481 -272.318C55.6765 -274.746 60.4693 -276.015 65.3441 -276C70.2188 -275.984 75.0034 -274.684 79.2161 -272.229C83.4288 -269.774 86.9208 -266.252 89.3405 -262.017C91.7603 -257.782 93.0224 -252.984 92.9997 -248.106Z",
    fill: "#4AEAEB"
  })));
};
Triangle4.defaultProps = {
  className: undefined,
  style: undefined
};
var Triangle4$1 = Triangle4;

export { Triangle4$1 as default };
